import React from 'react';

import openNewWindow from '../../utils/openNewWindow';
import styles from './styles/blog-card.module.css';

import {ReactComponent as ArrowRightImg} from '../../assets/main03/arrow-right.svg';

export default function BlogCard({ Thumbnail, title, content, link }) {
  return (
    <div className={styles.wrapper}  onClick={() => openNewWindow(link)}>
      <div className={styles.boxThumbnail}>
        <Thumbnail />
      </div>
      <div className={styles.boxTitle}>
        <p>{title}</p>
        <ArrowRightImg />
      </div>
      <p className={styles.content}>{content}</p>
    </div>
  );
}
